import React from 'react';
import { Avatar } from "../../widgets";
import { PLAN_TYPE_COLOURS } from '../../../constants/index';

const PlanTypeSelection = (props) => props.planTypeList.map((item) =>
    <Avatar
        key={item.plan_type_id}
        className="img-avatar"
        style={{
            ...props.isDisable && { cursor: "not-allowed", opacity: 0.7 },
            ...(props.activePlanType === item.plan_type_id) ? { borderColor: `#ffc807` } : { border: "none" }
        }}
        name={item.plan_type.split(" ")[0]}
        color={PLAN_TYPE_COLOURS[item.plan_type_id]}
        singleLetterAvatar={true}
        onClick={props.isDisable ? null : () => props.handlePlanType(item.plan_type_id)}
    />)

export default PlanTypeSelection;